export default function AlertPopup({ children, className = "", onClick }) {
	const clickable = typeof onClick === "function";

	return (
		<div
			className={"alert-popup fadeInUp-animation " + className + (clickable ? " clickable" : "")}
			onClick={onClick}
			role={clickable ? "button" : undefined}
			tabIndex={clickable ? 0 : undefined}
			onKeyDown={
				clickable
					? (event) => {
							if (event.key === "Enter" || event.key === " ") {
								event.preventDefault();
								onClick();
							}
					  }
					: undefined
			}
		>
			{children}
		</div>
	);
}
